// 自分自身を呼び出しているのはテストでspyを有効にするため
import * as AuthContainer from '.';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { agencyActions } from '../../../redux/modules/Actions';
import Auth from '../../../component/templates/Auth';
import * as SessionApi from '@common/external/SessionApi';
import { JudgeSessionResponse } from '@common/external/SessionApi';
import { AgencyUserInfo } from '../../../redux/reducers/UserReducer';
import Cookies from 'js-cookie';
import { actions } from '@common/redux/modules/Actions';
import { storesApi, StoresApiRequest, StoresApiResponse } from '@common/external/StoresApi';
import CryptoJS from 'crypto-js';
import { getSearchParamsList } from '@common/utils/ParseURL';
import Axios from 'axios';
import { SORRY_MESSAGE_TYPE } from '@common/redux/reducers/SorryMessageReducer';
import { base64EncodeUnicode } from '@common/utils/Encryption';
import { UserInfo } from '@common/redux/reducers/UserReducer';
import { categoryGetApi, CategoryGetApiRequest } from '@common/external/CategoryApi';
import { LargeCategory, SearchCategoryState } from '@common/redux/reducers/SearchCategoryReducer';
import { messageListApiPost, MessageListApiRequest } from '@common/external/MessageListApi';
import { masterDetailApiGetAllDisplayItem, masterDetailApiGetAllPcmCode } from '@common/external/MasterDetailApi';
import { masterItemImageApiGet } from '@common/external/MasterItemImageApi';
import { masterMessageDisplayMethodApiGet } from '@common/external/MessageDisplayMethodListApi';
import { masterApiGetAllProhibitedWord } from '@common/external/MasterProhibitedWordApi';
import { masterApiGetAllApplicationVariableInfo } from '@common/external/MasterApplicationVariableApi';
import { initDataLayer } from '@common/utils/DataLayer';
import { initializeGTM } from '@common/utils/GoogleTagManager';
import { masterDetailApiGetAllAnnotation } from '@common/external/MasterAnnotationsApi';

const secretKey = process.env.REACT_APP_SECRET_KEY || 'SecretKey';
const auth0url = process.env.REACT_APP_AUTH0_URL || '';
const cryptogram = process.env.REACT_APP_CRYPTOGRAM;
const moduleAgency = process.env.REACT_APP_MODULE;
const agencyCdForAgencyModule = process.env.REACT_APP_AGENCY_CD;
const externalUser = '04';

const SORT_FIELDS = ['kanaName', 'longName', 'shortName', 'companyCfc'] as const;

export interface AuthInfo {
  crewCd: string;
  crewName: string;
  classCd: string;
  postFlg: string;
  postCd: string;
  key: string;
  proxyloginowner: string;
}

/**
 * cookie あり param あり → authなし paramで更新
 * cookie あり param なし → authなし
 * cookie なし param あり → authなし
 * cookie なし param なし → authあり
 */
export async function createAgencyUserInfo(search: string, dispatch: Dispatch): Promise<UserInfo> {
  let authInfo: AuthInfo = getSearchParamsList(search);

  if (search !== '' && (authInfo.crewCd === '' || authInfo.crewName === '' || authInfo.postFlg === '' || authInfo.postCd === '')) {
    console.error('代理店ユーザ情報の取得に失敗しました。');
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.LOGIN_FAILED));
    throw new Error('9999');
  }

  if (authInfo.crewCd === '' || authInfo.crewName === '' || authInfo.postFlg === '' || authInfo.postCd === '') {
    const cookieUserInfo = Cookies.get('userInfo') || '';
    if (cookieUserInfo !== '') {
      try {
        authInfo = JSON.parse(CryptoJS.AES.decrypt(cookieUserInfo, secretKey).toString(CryptoJS.enc.Utf8));
      } catch (error) {
        console.error('ユーザー情報のマッピングに失敗しました。');
        dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.LOGIN_FAILED));
        throw new Error();
      }
    }
  }

  if (!authInfo.crewCd) {
    redirectToAuth0(dispatch);
    return Promise.reject('Auth0にリダイレクトします。');
  }

  initDataLayer({
    crewCd: '',
    agencyCd: '',
    employeeNumber: authInfo.crewCd,
  });

  if (authInfo.postFlg === externalUser) {
    if (authInfo.classCd === '') {
      console.error('外部ユーザの代理店コードがありません。');
      dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
      throw new Error('9999');
    }
  }

  if (authInfo.classCd === '') {
    console.error('アクセス権限のないユーザでログインしました。');
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.PERMIT_LOGIN));
    throw new Error('アクセス権限のないユーザでログインしました。');
  }

  const loginInfo = {
    crewCd: authInfo.crewCd,
    crewName: authInfo.crewName,
    classCd: authInfo.classCd,
    postFlg: authInfo.postFlg,
    postCd: authInfo.postCd,
    key: base64EncodeUnicode(authInfo.key),
    proxyloginowner: authInfo.proxyloginowner,
  };

  // ユーザー権限判定用設定を全Axiosに適用
  Axios.defaults.headers.common['userId'] = loginInfo.crewCd;
  Axios.defaults.headers.common['cryptogram'] = cryptogram;
  Axios.defaults.headers.common['module'] = moduleAgency;
  Axios.defaults.headers.common['agencyCd'] = agencyCdForAgencyModule;
  if (authInfo.proxyloginowner !== '') {
    Axios.defaults.headers.common['proxyloginowner'] = authInfo.proxyloginowner;
  }

  const req: StoresApiRequest = {
    userId: loginInfo.crewCd,
    classCd: loginInfo.classCd,
    postCd: loginInfo.postCd,
  };

  const storesResponse: StoresApiResponse = await storesApi(req);
  if (storesResponse.stores === undefined) {
    console.error('取次店情報の取得に失敗しました。');
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
    throw new Error('取次店情報の取得に失敗しました。');
  }
  if (storesResponse.stores.length === 0) {
    console.error('ログイン情報に紐づく取次店情報がありません。');
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.PERMIT_LOGIN));
    throw new Error('ログイン情報に紐づく取次店情報がありません。');
  }

  storesResponse.stores.sort((a, b) => {
    for (const sortField of SORT_FIELDS) {
      const compare = String(a[sortField]).localeCompare(String(b[sortField]), 'ja');
      if (compare !== 0) return compare;
    }
    return a.agencyCd.localeCompare(b.agencyCd, 'ja');
  });

  const browsableStores: string[] = storesResponse.stores
    .filter((storeInfo) => storeInfo.agencyCd !== storeInfo.mngcstmCd)
    .map(({ agencyCd }) => agencyCd);

  const userInfo: AgencyUserInfo = {
    crewCd: loginInfo.crewCd || '',
    crewName: loginInfo.crewName || '',
    stores: storesResponse.stores,
    browsableStores: browsableStores,
    isLoggedIn: true,
    classCd: loginInfo.classCd || '',
    postFlg: loginInfo.postFlg || '',
    postCd: loginInfo.postCd || '',
    proxyloginowner: loginInfo.proxyloginowner || '',
  };

  // 必ずUserのログイン情報を更新してから店舗情報を更新すること
  // この順序はLatestSummaryComponentのcomponentWillUpdateに依存する
  dispatch(agencyActions.loginAgencyUser.updateAgencyUser(userInfo));
  dispatch(actions.storeSelector.initialize.store(storesResponse.stores));
  // dispatch(actions.storeSelector.updateSelectedStores(browsableStores));

  Cookies.set('userInfo', CryptoJS.AES.encrypt(JSON.stringify(authInfo), secretKey).toString(), { expires: 1 / 3 });

  return userInfo;
}

export function judgeSessionInterceptor(crewCd: string, dispatch: Dispatch): void {
  SessionApi.judgeSessionInterceptor(
    crewCd,
    // eslint-disable-next-line
    (res: JudgeSessionResponse) => {
      // ログイン済み
      dispatch(agencyActions.updateLogInStatus(true));
    },
    // eslint-disable-next-line
    (error) => {
      // インタセプター エラー
      dispatch(agencyActions.signOut());
      redirectToAuth0(dispatch);
    }
  );
}

export async function registerSession(crewCd: string, history: any, dispatch: Dispatch): Promise<void> {
  if (Cookies.get('sessionId') !== undefined) {
    // リロードしたときにログインステータスがデフォルトのfalseになってしまい後続APIが呼ばれないので設定する
    dispatch(agencyActions.updateLogInStatus(true));
    return;
  }
  const res = await SessionApi.registerSession({ userId: crewCd });
  dispatch(agencyActions.updateLogInStatus(res.result));
  if (!res.result) {
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
    AuthContainer.redirectSorryPage(history);
  } else {
    AuthContainer.redirectDushboardPage(history);
  }
}

export function redirectToAuth0(dispatch: Dispatch): void {
  console.log('Auth0にリダイレクトします。');
  dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.LOGIN_TRANSITION));
  window.location.replace(auth0url);
}

export function redirectSorryPage(history: any): void {
  Cookies.remove('sessionId');
  Cookies.remove('userInfo');
  history.replace('/sorry');
}

export function redirectDushboardPage(history: any): void {
  // urlにあるクエリパラメータを消す
  history.replace('/');
}

/* istanbul ignore next */
const mapStateToProps = () => {
  return {};
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    initial: (param: string, history: any) => {
      createAgencyUserInfo(param, dispatch)
        .then(async (userInfo) => {
          initializeGTM();
          judgeSessionInterceptor(userInfo.crewCd, dispatch);
          await registerSession(userInfo.crewCd, history, dispatch);
          await fetchMasterInfo(dispatch);
          initCategory(dispatch, userInfo);
        })
        // eslint-disable-next-line
        .catch((error) => {
          AuthContainer.redirectSorryPage(history);
        });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);

// カテゴリ初期化
export function initCategory(dispatch: Dispatch, loginUser: UserInfo) {
  const agencyCd: string[] = loginUser.browsableStores ? loginUser.browsableStores : [];

  // リクエスト作成
  const request = makeCategoryApiRequest(loginUser, agencyCd);

  // API呼び出し
  categoryGetApi(request).then((response) => {
    let resultLargeCategory: LargeCategory[] = [];
    const largeCategory = response.largeCategory;

    if (largeCategory) {
      resultLargeCategory = largeCategory;
    }

    const ret: SearchCategoryState = {
      key: {
        userId: loginUser.crewCd,
        agencyCd: agencyCd,
      },
      categories: resultLargeCategory,
    };

    dispatch(actions.updateSearchCategory(ret));
  });
}

function makeCategoryApiRequest(loginUser: UserInfo, agencyCd: string[]): CategoryGetApiRequest {
  const req: CategoryGetApiRequest = {
    userId: loginUser.crewCd,
    agencyCd: agencyCd,
  };

  return req;
}

const fetchMasterInfo = async (dispatch: Dispatch) => {
  const messageListApiRequest: MessageListApiRequest = {
    level: 1,
    display_flg: true,
    api_flg: false,
    batch_flg: false,
  };
  const { messageList } = await messageListApiPost(messageListApiRequest);
  const { messageDisplayMethodList } = await masterMessageDisplayMethodApiGet();
  const { displayItemList } = await masterDetailApiGetAllDisplayItem();
  const { pcmCodeDivisionList } = await masterDetailApiGetAllPcmCode();
  const { annotationMstList } = await masterDetailApiGetAllAnnotation();
  const { itemImageList } = await masterItemImageApiGet();
  const { prohibitedWordMstList } = await masterApiGetAllProhibitedWord();
  const { applicationVariableMstList } = await masterApiGetAllApplicationVariableInfo();

  dispatch(
    actions.fetchMasterInfo({
      messageList: messageList,
      messageDisplayMethodList: messageDisplayMethodList,
      displayItemList: displayItemList,
      pcmCodeDivisionList: pcmCodeDivisionList,
      annotationMstList: annotationMstList,
      itemImageList: itemImageList,
      prohibitedWordMstList: prohibitedWordMstList,
      applicationVariableMstList: applicationVariableMstList,
    })
  );
};
